



























import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { QuestionnaireGlossaryItem } from "../../../../../../domain/questionnaire";

@Component
export default class QuestionnaireGlossaryItemSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: () => [] as QuestionnaireGlossaryItem[] })
  options: QuestionnaireGlossaryItem[];

  $refs!: {
    table: ElTable,
  };

  onClicked(row: QuestionnaireGlossaryItem) {
    this.editingSource = row;
  }
}
